import { useIsMobile } from "@tokenterminal/ui/hooks/isMobile"
import { colorsV4 } from "@tokenterminal/ui/theme/themeV4/colorsContract.css"
import TableMockMobile from "@/icons/table-mobile.svg"
import TableMock from "@/icons/table.svg"

const TableMockImage = () => {
  const isMobile = useIsMobile()

  const TableMockImg = isMobile ? TableMockMobile : TableMock
  return <TableMockImg color={colorsV4.border.default} />
}

export default TableMockImage
